import React from "react";
import { useNavigate } from "react-router-dom";

const Home = () => {
    const navigate = useNavigate();

    const quickActions = [
        {
            label: "توليد QR",
            icon: "bi-qr-code-scan",
            path: "/admin/generate-uid",
            color: "#0dcaf0",
            description: "إنشاء رموز الاستجابة السريعة الذكية للفعاليات"
        },
        {
            label: "عرض الفعاليات",
            icon: "bi-building-check",
            path: "/admin/establishments",
            color: "#198754",
            description: "إدارة ومتابعة كافة المنشآت والفعاليات"
        },
        {
            label: "عرض الشكاوي",
            icon: "bi-chat-right-dots",
            path: "/admin/all-complaint",
            color: "#dc3545",
            description: "نظام معالجة وتدقيق شكاوي المواطنين"
        },
        {
            label: "أنواع الضبوط",
            icon: "bi-shield-exclamation",
            path: "/admin/violation-types-management",
            color: "#6f42c1",
            description: "الدليل الموحد لأنواع المخالفات والضبوط"
        },
    ];

    return (
        <div className="container-fluid py-5" style={{ direction: "rtl", minHeight: "100vh", background: "linear-gradient(180deg, #ffffff 0%, #f1f4f8 100%)" }}>

            {/* قسم الهوية البصرية */}
            <div className="text-center mb-5 animate-fade-in">
                <div className="mb-4">
                    <img
                        src="/website-icon.png"
                        alt="شعار الجمهورية العربية السورية"
                        style={{
                            width: "160px",
                            height: "auto",
                            filter: "drop-shadow(0 10px 15px rgba(0,0,0,0.15))"
                        }}
                    />
                </div>
                <h1 className="fw-bold text-dark mb-2" style={{ fontSize: "1.8rem", letterSpacing: "1px" }}>
                    الجمهورية العربية السورية
                </h1>
                <h4 className="text-muted fw-light mb-4">المنظومة الإلكترونية لحماية المستهلك</h4>
                <div className="d-flex justify-content-center">
                    <div style={{ width: "40px", height: "3px", background: "#ce1126", margin: "0 2px" }}></div>
                    <div style={{ width: "40px", height: "3px", background: "#ffffff", margin: "0 2px", border: "1px solid #eee" }}></div>
                    <div style={{ width: "40px", height: "3px", background: "#007a3d", margin: "0 2px" }}></div>
                </div>
            </div>

            {/* لوحة التحكم السريعة */}
            <div className="container mt-5">
                <div className="row g-4 justify-content-center">
                    {quickActions.map((action, index) => (
                        <div key={index} className="col-12 col-sm-6 col-lg-3">
                            <div
                                onClick={() => navigate(action.path)}
                                className="card h-100 border-0 shadow-sm action-card p-4"
                                style={{
                                    borderRadius: "24px",
                                    background: "#ffffff",
                                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                    cursor: "pointer"
                                }}
                            >
                                <div
                                    className="icon-circle mb-4 d-flex align-items-center justify-content-center"
                                    style={{
                                        width: "80px",
                                        height: "80px",
                                        backgroundColor: `${action.color}10`,
                                        color: action.color,
                                        borderRadius: "20px",
                                        fontSize: "2.5rem"
                                    }}
                                >
                                    <i className={`bi ${action.icon}`}></i>
                                </div>
                                <h5 className="fw-bold text-dark mb-2">{action.label}</h5>
                                <p className="text-muted small lh-base">{action.description}</p>
                                <div className="mt-3 text-start">
                                    <span className="badge rounded-pill" style={{ backgroundColor: `${action.color}20`, color: action.color }}>
                                        دخول <i className="bi bi-arrow-left ms-1"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <style>{`
        .action-card:hover {
          transform: translateY(-12px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.08) !important;
        }
        
        .action-card:hover .icon-circle {
          background-color: inherit !important;
          background-image: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(0,0,0,0.05) 100%);
          transform: scale(1.05);
        }

        .animate-fade-in {
          animation: fadeIn 1s ease-in-out;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        body {
          background-color: #f8f9fa;
        }
      `}</style>
        </div>
    );
};

export default Home;